var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hk-pagination flex flex-center"},[_c('el-pagination',{attrs:{"background":"","page-size":20,"layout":"prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }